/**
 * config/cutTargets.ts — Mapping `lateralResistanceConfig` → CutTarget.
 *
 * Boundary rule (SPEC §6, PLAN §1.2): `config/` contains EVERY constant and
 * mapping. The `CutTarget` (SPEC §2.8, G7) determines the notch/cut of the beam:
 * - "header-column" → cut on the header beam in COLUMN configuration
 * - "header-beam" → cut on the header beam in BEAM configuration
 * - "joist-beam" → cut on the joist beam
 * - "none" → no shear (no lateral resistance required)
 *
 * CENTRALIZED mapping to be easily correctable when the
 * real data (R3).*/

import type { CutTarget } from "../data/types";

/**
 * Mapping `lateralResistanceConfig` (0–4) → CutTarget (PLAN §2.7).
 *
 * TODO(R3, SPEC G7): TEMPORARY VALUES — to be verified and corrected with data
 * DB reals. The mapping is centralized here specifically to be easy to
 * correct. T6/T8 completion criteria: 0 → "none".*/
export const LATERAL_RESISTANCE_TO_CUT_TARGET: Record<number, CutTarget> = {
  0: "header-column",
  1: "header-beam",
  2: "joist-beam",
  3: "none",
  4: "none",
};

/**
 * Resolve CutTarget from form input (PLAN §2.7).
 *
 * Input `null` or outside known values (0–4) → "none" (no cut):
 * the configurator must remain robust with a form not yet filled out.
 *
 * @param config The form's `lateralResistanceConfig` value (0–4 or null).
 * @returns CutTarget fixed; "none" for null/out-of-range.*/
export function lateralResistanceToCutTarget(config: number | null, orientation: "beam" | "column"): CutTarget {
  if (config === null) return "none";
  const target = LATERAL_RESISTANCE_TO_CUT_TARGET[config] ?? "none";
  if (target === "header-column" && orientation !== "column") return "none";
  if (target === "header-beam" && orientation !== "beam") return "none";
  return target;
}
